import { useTranslations } from '@vocab/react';
import { Box, TextLinkButton, IconFlag, Text } from 'braid-design-system';
import { useDispatch } from 'react-redux';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { REPORT_PROFILE } from 'src/components/Router';
import { updateRoute } from 'src/components/Router/actionCreators';
import { EDIT } from 'src/consts';
import { REPORT_PROFILE_FORM } from 'src/reducers/forms';

import translations from './.vocab';
import { ReportProfileForm } from './ReportProfileForm';

export const ReportProfile = () => {
  const { t } = useTranslations(translations);
  const dispatch = useDispatch();

  const onClickHandler = () => {
    dispatch(
      updateRoute({
        to: REPORT_PROFILE,
        mode: EDIT,
      }),
    );
  };

  return (
    <Box>
      <Box paddingTop="medium">
        <Text
          size="small"
          align={{ mobile: 'center', tablet: 'right' }}
          tone="secondary"
        >
          <TextLinkButton
            icon={<IconFlag />}
            onClick={onClickHandler}
            hitArea="large"
            weight="weak"
            data={{ automation: 'report-profile-button' }}
          >
            {t('Report this profile')}
          </TextLinkButton>
        </Text>
      </Box>
      <FormDrawer
        title={t('Report this profile')}
        component={ReportProfileForm}
        card={REPORT_PROFILE}
        formName={REPORT_PROFILE_FORM}
      />
    </Box>
  );
};
